import { StyleSheet } from 'react-native';
import { brand, neutrals } from 'src/theme/colors';

export const styles = StyleSheet.create({
  details: {
    alignItems: 'center',
    gap: 31,
  },
  text: {
    color: neutrals.neutralGrays.tarmac,
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 22,
    textAlign: 'center',
  },
  textWrapper: { alignItems: 'center', gap: 11 },
  button: {
    width: 200,
    backgroundColor: brand.main.water,
    borderRadius: 25,
    paddingVertical: 11,
    paddingHorizontal: 50,
    shadowColor: brand.main.variations['lighterWater-2'],
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 8,
    elevation: 4,
  },
  buttonText: {
    color: neutrals.white,
    fontSize: 18,
    fontWeight: 700,
    lineHeight: 27,
    textAlign: 'center',
  },
  title: {
    fontWeight: 700,
    fontSize: 20,
    color: neutrals.neutralGrays.graphite,
  },
});

export const newStyles = StyleSheet.create({
  textWrapper: {
    alignItems: 'center',
    gap: 11,
  },
  details: {
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    gap: 24,
  },
  button: {
    width: 217,
    height: 50,
  },
});
